import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  id: "hub-tab-container-last-mile",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "px-6 py-3 flex items-center" }
const _hoisted_4 = { class: "text-xl text-black-lp-300 font-semibold" }
const _hoisted_5 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100 pb-2",
  style: {"padding-top":"10px","height":"42px"}
}
const _hoisted_6 = {
  class: "flex flex-row items-center font-semibold gap-6  text-gray-lp-600",
  ref: "tab-link-container"
}
const _hoisted_7 = {
  id: "tab-content",
  class: "w-full h-full pb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["w-full border-t border-gray-lp-400", _ctx.isSidebarAndBreadcrumbV2 ? '' : 'mt-3']
      }, null, 2),
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ path: '/dashboard', query: { activeMenu: 'hanging-last-mile' }}))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "back"
        }),
        _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.hanging.historyLastMileTitle')), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_Fragment, null, [
              (tab.permission)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: tab.name,
                    to: tab.path,
                    class: "px-4 h-7",
                    ref: tab.refName,
                    exactActiveClass: "text-red-lp-100 border-b-2 border-red-lp-100 pb-5",
                    activeClass: "text-red-lp-100 border-b-2 border-red-lp-100 pb-5",
                    style: {"line-height":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ], 512)
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_router_view)
    ])
  ]))
}